namespace Solovis.Reports.BatchDataSetLoader {

    export interface BatchDataSetRequest {
        path?: string;
        code?: string;        
        options: any;
        reportCode?: string;
        caching?: any;
        dataContext?: ReportDataContext;
        requestId?: string;
        xhrRequestOptions: any;
        callback: (response, success) => void;
    }

    // BatchDataSetLoader._pendingDataSetRequests maintains a list of request that need to be submitted.
    export var _pendingDataSetRequests: BatchDataSetRequest[] = [];

    // BatchDataSetLoader._requestIdToOutstandingRequestMap maintains a map of request ids that have been submitted to requests.
    export var _requestIdToOutstandingRequestMap: { [id: string]: BatchDataSetRequest } = {};

    // BatchDataSetLoader._requestCheckInterval maintains handle for timer that checks for need to submit batched data sets.
    export var _requestCheckInterval = null; 


    export function submitBatchDataSetRequest(request: BatchDataSetRequest) {
        BatchDataSetLoader._pendingDataSetRequests.push(request);

        if (!BatchDataSetLoader._requestCheckInterval) {
            BatchDataSetLoader._requestCheckInterval = setInterval(BatchDataSetLoader._batchSubmitInterval, 1);
        }
    }

    /**
     * Handler to check to see if we need to submit a batch of queued data set requests.
     */
    export function _batchSubmitInterval() {
        if (BatchDataSetLoader._pendingDataSetRequests.length > 0) {
            var requestsToSubmit: any[] = [];
            let xhrRequestOptions = undefined;

            let pendingDataSetRequestsWithXhrOptions = BatchDataSetLoader._pendingDataSetRequests.filter(x => x.xhrRequestOptions != null);
            if (pendingDataSetRequestsWithXhrOptions.length > 0) {
                xhrRequestOptions = pendingDataSetRequestsWithXhrOptions[0].xhrRequestOptions;
            }

            for (let request of BatchDataSetLoader._pendingDataSetRequests) {
                var batchRequest = {
                    path: request.path,
                    code: request.code,
                    options: request.options,
                    reportCode: request.reportCode,
                    caching: request.caching,
                    dataContext: request.dataContext,
                    requestId: request.requestId
                };

                requestsToSubmit.push(batchRequest);
                BatchDataSetLoader._requestIdToOutstandingRequestMap[request.requestId] = request;
            }

            BatchDataSetLoader._pendingDataSetRequests = [];

            Solovis.Rpc.invoke(
                "~/Rpc/DataSource/BatchLoadDataSets",
                { requests: requestsToSubmit },
                function (response, success) {
                    if (success) {
                        var results = response.result.results;
                        $(results).each(function (i, dataSetResult) {
                            BatchDataSetLoader._handleBatchedDataSetResponse(dataSetResult);
                        });
                    }
                    else {
                        // Return failure for all requested data sets in this batch.
                        for (let request of requestsToSubmit) {
                            var errorResponse = {
                                requestId: request.requestId,
                                error: response.error
                            };

                            BatchDataSetLoader._handleBatchedDataSetResponse(errorResponse);
                        };
                    }
                },
                xhrRequestOptions
            );
        }

        if (BatchDataSetLoader._requestCheckInterval) {
            clearInterval(BatchDataSetLoader._requestCheckInterval);
            BatchDataSetLoader._requestCheckInterval = null;
        }
    }

    export function _handleBatchedDataSetResponse(dataSetResult) {
        var request = BatchDataSetLoader._requestIdToOutstandingRequestMap[dataSetResult.requestId];
        if (request) {
            delete BatchDataSetLoader._requestIdToOutstandingRequestMap[dataSetResult.requestId];

            if (request.callback) {
                var dataSetSuccess = dataSetResult.error ? false : true;
                if (dataSetSuccess) {
                    request.callback({ result: dataSetResult }, dataSetSuccess);
                }
                else {
                    request.callback({ error: dataSetResult.error }, dataSetSuccess);
                }
            }
        }
    }
}
